// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_2h6HA4MXIwl-KVZs5aKYDi","instructions":"_2f2EA1qnmV2hmr_X_uKOtf"};